var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostCh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_die_post",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LogoDiePost"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.000367,
    y: -0.000285,
    width: 55.999996,
    height: 56.000004,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0000",
    points: "26.444813,25.121939 26.444813,14.777493 15.32259,14.777493 15.32259,22.633049 7.778145,22.633049  7.778145,33.366386 15.32259,33.366386 15.32259,41.221939 26.444813,41.221939 26.444813,30.877495 23.800367,30.877495  23.800367,38.733047 17.967033,38.733047 17.967033,30.877495 10.422589,30.877495 10.422589,25.121939 17.967033,25.121939  17.967033,17.266382 23.800367,17.266382 23.800367,25.121939  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.659962,24.192696c0,1.876564-1.548973,3.340361-3.513401,3.340361h-2.990635v-6.455555h2.990639 C40.186604,21.077494,41.659962,22.391075,41.659962,24.192696z M39.431103,14.777493H28.000366v26.444447h7.15556v-7.855553 h4.275181c5.251015,0,9.331078-4.006624,9.331078-9.182213C48.76218,18.970772,44.606693,14.777493,39.431103,14.777493z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostCh);
export default __webpack_public_path__ + "static/media/post-ch.c7252d46.svg";
export { ForwardRef as ReactComponent };